module.exports = __webpack_public_path__ + "assets/dd3bcbadc046e710175633ce5b5f9839.png";